import React from 'react';
import { Card, Space, Typography, theme } from 'antd';
import { HolderOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

/**
 * Full-width dashboard text section — view or editor chrome (drag handle + actions).
 */
export default function ReportingTextBlockSection({
    item,
    dragHandleClassName,
    extra,
}) {
    const { token } = theme.useToken();
    const body = (
        <div
            className="no-drag"
            style={{
                padding: dragHandleClassName || extra ? '12px 16px 16px' : '20px 24px',
                height: '100%',
                boxSizing: 'border-box',
                overflow: 'auto',
            }}
        >
            {item.title ? (
                <Title level={4} style={{ margin: 0, fontWeight: 600, lineHeight: 1.35 }}>
                    {item.title}
                </Title>
            ) : null}
            {item.description ? (
                <Paragraph
                    style={{
                        marginTop: item.title ? 10 : 0,
                        marginBottom: 0,
                        color: token.colorTextSecondary,
                        fontSize: 15,
                        lineHeight: 1.55,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {item.description}
                </Paragraph>
            ) : null}
        </div>
    );

    if (dragHandleClassName || extra) {
        return (
            <Card
                size="small"
                style={{ height: '100%', borderRadius: 10 }}
                styles={{
                    body: { padding: 0, height: extra ? 'calc(100% - 36px)' : '100%', overflow: 'hidden' },
                    header: extra ? { minHeight: 36, padding: '0 8px', borderBottom: `1px solid ${token.colorBorderSecondary}` } : undefined,
                }}
                title={dragHandleClassName ? (
                    <Space size={6}>
                        <span
                            className={dragHandleClassName}
                            style={{
                                cursor: 'grab',
                                userSelect: 'none',
                                color: token.colorTextTertiary,
                                lineHeight: 1,
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '2px 4px',
                            }}
                            aria-label="Drag section"
                        >
                            <HolderOutlined />
                        </span>
                        <span className="no-drag" style={{ fontSize: 11, color: token.colorTextTertiary }}>
                            Text section
                        </span>
                    </Space>
                ) : null}
                extra={extra ? <Space size={4} className="no-drag" onClick={e => e.stopPropagation()}>{extra}</Space> : null}
            >
                {body}
            </Card>
        );
    }

    return (
        <div
            style={{
                height: '100%',
                borderRadius: 10,
                background: `linear-gradient(180deg, ${token.colorFillQuaternary} 0%, ${token.colorBgContainer} 100%)`,
                border: `1px solid ${token.colorBorderSecondary}`,
                boxShadow: `0 1px 2px ${token.colorFillSecondary}`,
            }}
        >
            {body}
        </div>
    );
}
